import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { TemplateId } from 'data/templates/api';
import { ProjectTemplateTask } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getAllTasksSelector = () =>
  createSelector(
    (state: RootState) => state.templates.project,
    (_, templateId: TemplateId) => templateId,
    (project, templateId): { [key: string]: ProjectTemplateTask } =>
      project.data[templateId].tasks,
  );

export const useGetAllTasks = (): { [key: string]: ProjectTemplateTask } => {
  const templateId = useActiveTemplateId();
  const templateObject = useMemo(getAllTasksSelector, []);

  return useSelector((state: RootState) => templateObject(state, templateId));
};
